import { cx } from "../../lib/cx.js";
/* empty css              */
import { jsx, jsxs } from "react/jsx-runtime";
var escape = (query) => query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
/** Each match's [start, end) in `text`. */
function findMatches(text, query) {
	const needle = query?.trim();
	if (!needle) return [];
	return [...text.matchAll(new RegExp(escape(needle), "giu"))].map((match) => [match.index, match.index + match[0].length]);
}
/**
* The [start, end) of the window around the first match (or the text's start): about a
* third of it before the match, each cut moved to a word boundary when one is near.
*/
function excerptWindow(text, first, length) {
	if (text.length <= length) return [0, text.length];
	const [matchStart, matchEnd] = first ?? [0, 0];
	let start = Math.max(0, Math.min(matchStart - Math.floor(length / 3), text.length - length));
	if (start > 0) {
		const space = text.indexOf(" ", start);
		if (space !== -1 && space < matchStart) start = space + 1;
	}
	let end = Math.max(Math.min(start + length, text.length), matchEnd);
	if (end < text.length) {
		const space = text.lastIndexOf(" ", end);
		if (space > matchEnd) end = space;
	}
	return [start, end];
}
/**
* Text with a search query's matches marked: Line-item Search's "show what matched".
* Renders inline (a span), so it sits in a table cell or a line of text.
*/
function Highlight({ text, query, excerpt, label, className, ...rest }) {
	const matches = findMatches(text, query);
	const excerpted = excerpt !== void 0 && excerpt !== false;
	const [from, to] = excerpted ? excerptWindow(text, matches[0], excerpt === true ? 80 : excerpt) : [0, text.length];
	const parts = [];
	let at = from;
	for (const [start, end] of matches) {
		if (end <= from || start >= to) continue;
		if (start > at) parts.push(text.slice(at, start));
		parts.push(/* @__PURE__ */ jsx("mark", {
			className: "ds-highlight__mark",
			children: text.slice(Math.max(start, from), Math.min(end, to))
		}, start));
		at = Math.min(end, to);
	}
	if (at < to) parts.push(text.slice(at, to));
	return /* @__PURE__ */ jsxs("span", {
		className: cx("ds-highlight", excerpted && "ds-highlight--excerpt", className),
		...rest,
		children: [
			label && /* @__PURE__ */ jsxs("span", {
				className: "ds-highlight__label",
				children: [label, " "]
			}),
			from > 0 && "…",
			parts,
			to < text.length && "…"
		]
	});
}
//#endregion
export { Highlight, excerptWindow, findMatches };

//# sourceMappingURL=Highlight.js.map